import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { goerli } from 'viem/chains'


const projectId = process.env.REACT_APP_PROJECT_ID

// 2. Create wagmiConfig
const metadata = {
  name: 'findtoken',
  description: 'findtoken',
  url: 'https://findtoken.xyz',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

const chains = [goerli]

export const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata })
// 3. Create modal
createWeb3Modal({ wagmiConfig, projectId, chains })